export const DOCUMENT_CATEGORIES = ['minutes', 'report', 'announcement', 'other'];

export const CATEGORY_TONE = {
  minutes: 'cotisation',
  report: 'pelerinage',
  announcement: 'admin',
  other: 'inactive',
};

export const CATEGORY_ICON = {
  minutes: '📝',
  report: '📊',
  announcement: '📣',
  other: '📄',
};

/** Plain-text excerpt for cards; the HTML is already sanitised server-side. */
export function htmlExcerpt(html, max = 180) {
  if (!html) return '';
  const text = new DOMParser().parseFromString(html, 'text/html').body.textContent || '';
  const clean = text.replace(/\s+/g, ' ').trim();
  return clean.length > max ? `${clean.slice(0, max).trimEnd()}…` : clean;
}
